/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfOperationalPrivateFileDto } from "../models/AjaxResponseOfListOfOperationalPrivateFileDto";
import type { AjaxResponseOfOperationalPrivateFileDto } from "../models/AjaxResponseOfOperationalPrivateFileDto";
import type { AjaxResponseOfPresignOperationalPrivateFileUploadOutput } from "../models/AjaxResponseOfPresignOperationalPrivateFileUploadOutput";
import type { PresignOperationalPrivateFileUploadInput } from "../models/PresignOperationalPrivateFileUploadInput";
import type { RegisterOperationalPrivateFileInput } from "../models/RegisterOperationalPrivateFileInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalContactFilesAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfOperationalPrivateFileDto Success
   * @throws ApiError
   */
  public getAll({
    contactId,
  }: {
    contactId: number;
  }): CancelablePromise<AjaxResponseOfListOfOperationalPrivateFileDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/contacts/{contactId}/files",
      path: {
        contactId: contactId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalPrivateFileDto Success
   * @throws ApiError
   */
  public create({
    contactId,
    requestBody,
  }: {
    contactId: number;
    requestBody?: RegisterOperationalPrivateFileInput;
  }): CancelablePromise<AjaxResponseOfOperationalPrivateFileDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/contacts/{contactId}/files",
      path: {
        contactId: contactId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfPresignOperationalPrivateFileUploadOutput Success
   * @throws ApiError
   */
  public presignUpload({
    contactId,
    requestBody,
  }: {
    contactId: number;
    requestBody?: PresignOperationalPrivateFileUploadInput;
  }): CancelablePromise<AjaxResponseOfPresignOperationalPrivateFileUploadOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/contacts/{contactId}/files/presign-upload",
      path: {
        contactId: contactId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    contactId,
    fileId,
  }: {
    contactId: number;
    fileId: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/contacts/{contactId}/files/{fileId}",
      path: {
        contactId: contactId,
        fileId: fileId,
      },
    });
  }
}
